import {reduxStore} from '../ReduxIndex';
import UserInfo from '../../../main/auth/UserInfo';
import Api from '../../Api';

export function setUserNotificationUpdate(basketCount, notificationCount) {
    reduxStore.dispatch({
        type: 'userNotificationUpdate',
        payload: {
            basketCount,
            notificationCount,
        },
    });
}

export function setUserAutoNotificationUpdate() {
    UserInfo.isSignedIn().then(function (isSignedIn) {
        if (isSignedIn.Id) {
            Api.getItemCounts(isSignedIn.Id).then(response => {
                const result = response.data.Result;
                if (result) {
                    setUserNotificationUpdate(result.BasketCount, result.NotificationCount);
                }
            });
        }
    });
}

export function setUserInfo(userInfo, userInfoStatus = false) {
    reduxStore.dispatch({
        type: 'userInfo',
        payload: {
            userInfo,
            userInfoStatus,
        },
    });
}
